import { render, staticRenderFns } from "./UsersAdminPanelHeader.vue?vue&type=template&id=7af10ec3&"
import script from "./UsersAdminPanelHeader.vue?vue&type=script&lang=ts&"
export * from "./UsersAdminPanelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./UsersAdminPanelHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports